import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as Globals from '../../globals';
import { Observable, of } from 'rxjs';
import { LocalStorage } from '@ngx-pwa/local-storage';
import { PayloadService } from '../payload/payload.service';
import { tap, switchMap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class PeersService {

    public payload;


    constructor(
        private http: HttpClient,
        public localStorage: LocalStorage,
        public payloadService: PayloadService
    ) { }

    list(): Observable<any> {
        return this.payloadService.getPayload().pipe(
            switchMap(
                (payload) =>{
                    return this.http.post(Globals.url_api + "peers/list", {
                        "payload": payload
                    });
                }
            )
        )
    }

    add(user, peer_number, bina, externalCall, mobileCall, voicemail, recordCall, accessRecords, downloadRecords, smart_bina): Observable<any> {
        return this.payloadService.getPayload().pipe(
            switchMap(
                (payload) =>{
                    return this.http.post(Globals.url_api + "peers/add", {
                        "payload": payload,
                        "user_crm_id": user.id,
                        "peer_number": peer_number,
                        "bina": bina,
                        "externalCall": externalCall,
                        "mobileCall": mobileCall,
                        "voicemail": voicemail,
                        "recordCall": recordCall,
                        "accessRecords": accessRecords,
                        "downloadRecords": downloadRecords,
                        "smart_bina" : smart_bina
                    })
                }
            )
        ) 
    }

    get(id): Observable<any> {
        return this.payloadService.getPayload().pipe(
            switchMap(
                (payload) =>{
                    return this.http.post(Globals.url_api + "peers/get", {
                        "payload": payload,
                        "id": id
                    });
                }
            )
        )  
    }

    edit(id, user, peer_number, bina, externalCall, mobileCall, voicemail, recordCall, accessRecords, downloadRecords, smart_bina): Observable<any> {
        return this.payloadService.getPayload().pipe(
            switchMap(
                (payload) =>{
                    return this.http.post(Globals.url_api + "peers/edit", {
                        "payload": payload,
                        "id": id,
                        "user_crm_id": user.id,
                        "peer_number": peer_number,
                        "bina": bina,
                        "externalCall": externalCall,
                        "mobileCall": mobileCall,
                        "voicemail": voicemail,
                        "recordCall": recordCall,
                        "accessRecords": accessRecords,
                        "downloadRecords": downloadRecords,
                        "smart_bina" : smart_bina
                    })
                }
            )
        )
    }

    delete(id): Observable<any> {
        return this.payloadService.getPayload().pipe(
            switchMap(
                (payload) =>{
                    return this.http.post(Globals.url_api + "peers/delete", {
                        "payload": payload,
                        "id": id
                    });
                }
            )
        )
    }
}
